export default __webpack_public_path__ + "static/pandaserver_landing-d2fdc65a135dfc08c96256db9ad2d11d.png";